import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import ModuleQuestion from "../../components/ModuleQuestion";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_4_1_2 = () => {
  const moduleNumber = 4;
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);


  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} moduleNumber={moduleNumber} />}

      <main className="col-sm-8 module-content">
        <section>
          <h1 className="blue text-uppercase b mt-5 mb-4">4.1.2 Case 2</h1>
          <p className="me-4">Estimated time to complete: 3-5 minutes</p>
        </section>
        <ModuleQuestion
          correctAnswer="A"
          assessmentName="challenge_case_2"
          videoTranscript={
            <>
              <p>
                <strong>AUDIO</strong>
                <br />
                VO: (FEMALE)
                <br />
                This is challenge case number 2. This is a positive case. I’m
                beginning at the level of the temporal region seen here. As you
                can see, there is significant image noise and likely some
                cortical thinning. However, in the left temporal region
                identified here, increased activity is seen in the gray matter
                exceeding that of the adjacent white matter. This alone would
                cause this case to be positive. However, let’s review the rest
                of this scan.
              </p>
              <p>
                Continuing to move upwards, once again, it is clear that there
                is significant thinning of the cortex. To confirm this, you can
                utilize the accompanying fused PET/CT images and, in fact, this
                is the case. Throughout the brain, there is significant cortical
                thinning, as well as ventriculomegaly. This may make it
                difficult to distinguish the white and gray matter. However, as
                we continue to move upwards and enter into a region where there
                is relative preservation of the cortex, as seen here, the white
                matter tracts are not delineated. There is increased activity in
                the adjacent gray matter and, therefore, there is loss of
                gray-white contrast throughout.
              </p>
              <p>
                Another area of relatively preserved cortex is also seen in the
                left parietal region identified here. Again, there is loss of
                gray-white contrast throughout. In areas where there is
                significant cortical thinning, as seen in the left occipital
                parietal region and in the frontal cortices bilaterally, there
                is also loss of gray-white contrast, although it may be more
                difficult to evaluate. Continuing upwards into the upper
                parietal regions once again, there is distinct loss of
                gray-white contrast, and white matter tracts are not visualized
                bilaterally. This scan is positive, even though there is
                significant atrophy and image noise, as there is loss of
                gray-white contrast in multiple regions, as well as focally
                increased activity in the cortical gray matter of the left
                temporal region. If you called this case negative, you may want
                to review the case once again in the MIMcloud Viewer.
              </p>
            </>
          }
          previousLesson="/module-4/module-4-1-1"
          nextLesson="/module-4/module-4-1-3"
          iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_1472097074&entry_id=1_ihnh4rdh&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
          videoId="1_ihnh4rdh"
        />
      </main>
    </div>
  );
};

export default Module_4_1_2;
